import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query'
import { ApiError } from '@/composables/useApi.js'

// roughly adapted from: https://github.com/TanStack/query/blob/main/examples/vue/nuxt3/plugins/vue-query.ts
export default defineNuxtPlugin({
  name: 'vue-query',
  setup(nuxt) {
    const config = useRuntimeConfig()

    const queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          retry(_failureCount, error: unknown) {
            // during automated tests we don't want to do any retries
            if (config.public.isTest) {
              return false
            }

            // we don't want to retry after 3 failed retries
            if (_failureCount === 3) {
              return false
            }

            return error instanceof ApiError && !error.is(404)
          },
        },
      },
    })

    nuxt.vueApp.use(VueQueryPlugin, {
      queryClient,
      enableDevtoolsV6Plugin: true,
    })
  },
})
